/* eslint-disable max-len */
/* eslint-disable no-prototype-builtins */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-undef */
import React, { useEffect, useState } from 'react';
import { CDN } from '../../../../constants';

export default function DistributorComments({ OrderDetails }) {
    const [reject, setReject] = useState(false);
    const findRoleName = (role, approver) => {
        const itemRrole = approver.find((item) => item?.approver === role);
        return itemRrole ? itemRrole.role_name : false;
    };
    useEffect(() => {
        setReject(findRoleName(OrderDetails?.order_cancelled_by?.role, OrderDetails?.approvals?.approval));
    }, [OrderDetails]);
    return (
        <div className="border border-[#CBC7C7] rounded-md bg-[#F5F5FA] h-auto p-3 my-4">
            <p className="font-semibold text-base text-[#090406]">Distributor Comments</p>
            <p className="my-2 font-normal text-sm text-[#555259] break-words">{OrderDetails?.instruction}</p>
            {OrderDetails?.po_document.length > 0 && OrderDetails?.po_document?.map((item) => (
                <div className="flex items-center flex-wrap">
                    <img src="/images/doc.svg" alt="icon" />
                    <p className="font-semibold text-sm text-[#000000] ml-1.5 break-words">{item?.split('/')?.at(-1)}</p>
                    <div className="flex items-center ml-4">
                        <img src="/images/download.svg" alt="icon" className="cursor-pointer" />
                        <p
                            className="text-[#5B5B5B] text-xs3 font-semibold ml-1 cursor-pointer"
                            onClick={() => {
                                window.open(`${CDN}/${item}`, '_blank');
                            }}
                        >
                            Download

                        </p>
                    </div>
                </div>
            ))}
            {OrderDetails?.po_additional_document.length > 0 && OrderDetails?.po_additional_document?.map((item) => (
                <div className="flex items-center">
                    <img src="/images/doc.svg" alt="icon" />
                    <p className="font-semibold text-sm text-[#000000] ml-1.5 break-all">{item?.split('/')?.at(-1)}</p>

                    <div className="flex items-center ml-4">
                        <img src="/images/download.svg" alt="icon" className="cursor-pointer" />
                        <p
                            className="text-[#5B5B5B] text-xs3 font-semibold ml-1 cursor-pointer"
                            onClick={() => {
                                window.open(`${CDN}/${item}`, '_blank');
                            }}
                        >
                            Download

                        </p>
                    </div>
                </div>
            ))}
            {OrderDetails?.workflow_comment
                && (
                    <>
                        <p className="text-[#090406] font-semibold text-base mt-3">WorkFlow Comments</p>
                        <p className="font-normal text-sm text-[#555259]">
                            {OrderDetails?.workflow_comment}
                        </p>

                    </>
                )}
            <p className="text-[#090406] font-semibold text-base mt-3 break-words">Ador Comments</p>
            {OrderDetails?.approvals.approval.map((item) => (
                <p className="font-normal text-sm text-[#555259] break-words">
                    <b>{item.role_name}</b>
                    {' '}
                    -
                    {' '}
                    {item?.role_name === reject && item?.note === '' ? 'Cancelled' : item.note}
                    <br />
                    {item?.role_name === reject
                        && <span>{`${OrderDetails?.order_cancelled_by?.employee_code} - ${OrderDetails?.order_cancelled_by?.first_name} ${OrderDetails?.order_cancelled_by?.last_name}`}</span>}
                </p>

            ))}
        </div>
    );
}
